"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.travelRooms = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const colors_1 = require("../basic/colors");
exports.travelRooms = (0, basic_1.applyBase)({
    closeButton: {},
    tooltipWrapper: {
        position: 'absolute',
        '.tooltip, .tooltipArrow': {
            visibility: 'visible',
            zIndex: 2,
            top: '-65px',
            left: '24px',
        },
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'background',
        minHeight: 'min-content',
        position: 'relative',
        p: 3,
        '.numeric-input-label': font_faces_1.FONT_SIZE.LARGE,
        '&:after': {
            content: ['', "''"],
            backgroundColor: 'lightGreyFirst',
            position: 'absolute',
            left: 3,
            bottom: 0,
            height: '1px',
            width: 'calc(100% - 32px)',
        },
        pb: [2, 3],
        '.adults, .children': {
            mb: 3,
        },
        '> *:not(:last-child)': {
            mb: 3,
        },
        '.room-1, .room-2': {
            '> *:not(:last-child)': {
                mb: 3,
            },
        },
        '.rooms-label-block': {
            display: 'flex',
            alignItems: 'center',
            '.icon': {
                width: '16px',
                height: '16px',
                ml: 3,
            },
        },
        '.children-DOB-Wrapper': {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
        },
    },
    childrenDOBWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '> *:not(:last-child)': {
            mb: 3,
        },
        '.childrenBirthTitle': font_faces_1.FONT_SIZE.SMALL,
        '.childrenBirthInput': {
            flex: '1 0 auto',
            maxWidth: ['120px', '135px'],
        },
    },
    manualTravelersInput: {
        borderTop: '1px solid',
        paddingTop: 3,
    },
    applyButton: {
        minHeight: 'min-content',
        position: 'sticky',
        alignSelf: 'flex-end',
        width: ['calc(100% - 32px)', 'auto'],
        mt: ['auto', 4],
        mx: 3,
        mb: 3,
        bottom: 'env(safe-area-inset-bottom)',
        left: 0,
        borderRadius: 4,
        '&:focus-visible': {
            outline: 'auto 2px',
            outlineOffset: '-1px',
            outlineColor: colors_1.baseColors.black,
        },
    },
});
//# sourceMappingURL=travel-rooms.js.map